/**
 * API Key Domain Types
 * Defines types for external API authentication
 */
/**
 * All available scopes with descriptions
 */
export const API_KEY_SCOPES = [
    { scope: 'operations:read', description: 'Read operations', category: 'Operations' },
    { scope: 'operations:create', description: 'Create operations', category: 'Operations' },
    { scope: 'operations:update', description: 'Update operations', category: 'Operations' },
    { scope: 'operations:delete', description: 'Delete operations', category: 'Operations' },
    { scope: 'accounts:read', description: 'Read account information', category: 'Accounts' },
    { scope: 'categories:read', description: 'Read categories', category: 'Categories' },
    { scope: 'counterparties:read', description: 'Read counterparties', category: 'Counterparties' },
    { scope: 'counterparties:create', description: 'Create counterparties', category: 'Counterparties' },
    { scope: 'payment-methods:read', description: 'Read payment methods', category: 'Payment Methods' },
    { scope: 'projects:read', description: 'Read projects', category: 'Projects' },
];
//# sourceMappingURL=api-key.js.map